import { MoreVertical } from "lucide-react"

const upcomingMeetings = [
  {
    id: 1,
    headline: "Team Standup Meeting",
    agenda: "Daily progress review",
    dueDate: "14 Mar 2025",
    participants: ["Tarun", "Anamika"],
    timeLeft: "08hr35min",
    avatarSrc1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoLa3ZawmmZG2JUGqgRwNEfoBF_1RCHEkxbw&s",
    avatarSrc2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_vqaibn1A23fkSjTjqSxU71gfAALi7ba3cA&s",
  },
  {
    id: 2,
    headline: "Project Review",
    agenda: "Q1 milestone discussion",
    dueDate: "15 Mar 2025",
    participants: ["John", "Sarah"],
    timeLeft: "1day 2hr",
    avatarSrc1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRb6Gl3IkRS0cV_kHT3vFRY2vPNDL0AZrvHhw&s",
    avatarSrc2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2lOQHK4HAH3hzhYwtJ_oVgzaaO7sjlDTrTA&s",
  },
  {
    id: 3,
    headline: "Client Presentation",
    agenda: "Product demo and feedback",
    dueDate: "16 Mar 2025",
    participants: ["Mike", "Lisa"],
    timeLeft: "2days 5hr",
    avatarSrc1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoLa3ZawmmZG2JUGqgRwNEfoBF_1RCHEkxbw&s",
    avatarSrc2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_vqaibn1A23fkSjTjqSxU71gfAALi7ba3cA&s",
  },
]

const deletedMeetings = [
  {
    id: 1,
    headline: "Cancelled Sprint Planning",
    agenda: "Sprint 12 planning session",
    dueDate: "12 Mar 2025",
    participants: ["Alex", "Emma"],
    avatarSrc1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSba-LMAbAgvoJdR4Z0qgNQz-BP70nFrTd3AA&s",
    avatarSrc2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNsJJ6y7jSi0ATS9DgFA7tKuE_z-jjbeRDOg&s",
  },
  {
    id: 2,
    headline: "Postponed Training Session",
    agenda: "New tool training",
    dueDate: "13 Mar 2025",
    participants: ["David", "Rachel"],
    avatarSrc1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBaXTFmlGCw3R4REI_V0WHxcSkMHwpTJVHNQ&s",
    avatarSrc2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCuydsp3RjWux3ih_fwNiTUpL5bu9mTxRk9Q&s",
  },
]

function MeetingCard({ meeting }) {
  return (
    <div className="meeting-card">
      <div className="meeting-header">
        <div>
          <h4 className="meeting-title">{meeting.headline}</h4>
          <p className="meeting-agenda">{meeting.agenda}</p>
          <p className="meeting-date">Due: {meeting.dueDate}</p>
        </div>
        <button className="more-button">
          <MoreVertical size={16} />
        </button>
      </div>

      <div className="participants">
        <div className="avatar-group">
          <img src={meeting.avatarSrc1 || "/placeholder.svg"} alt="Participant" className="participant-avatar" />
          <img src={meeting.avatarSrc2 || "/placeholder.svg"} alt="Participant" className="participant-avatar" />
        </div>
        <span className="participant-names">
          With <span className="highlight">{meeting.participants.join(", ")}</span>
        </span>
      </div>

      {meeting.timeLeft && (
        <div className="time-left">
          Time Left: <span className="time">{meeting.timeLeft}</span>
        </div>
      )}
    </div>
  )
}

export function RightSidebar({ isOpen, onClose }) {
  return (
    <aside className={`right-sidebar ${!isOpen ? "collapsed" : ""}`}>
      <div className="meetings-section">
        <h3 className="section-title">Upcoming Meetings</h3>
        {upcomingMeetings.map((meeting) => (
          <MeetingCard key={meeting.id} meeting={meeting} />
        ))}
      </div>

      <div className="meetings-section">
        <h3 className="section-title">Deleted Meetings</h3>
        {deletedMeetings.map((meeting) => (
          <MeetingCard key={meeting.id} meeting={meeting} />
        ))}
      </div>
    </aside>
  )
}
